export default "__VITE_ASSET__Cm5tgj8S__"